import { IGetS3DocumentPathParams, IGetS3TaskUploadPathParams } from './models'
import { v4 as uuidv4 } from 'uuid'
import { LocalizedError } from 'localization'

export function getUniqueS3DocumentPath({ caseId, branchId, extension }: IGetS3DocumentPathParams) {
	if (!caseId) throw new LocalizedError('materials.messages.caseIdMissing')
	if (!branchId) throw new LocalizedError('materials.messages.clientIdMissing')

	return `documents/${branchId}/${caseId}/${uuidv4()}.${extension}`
}

export function getS3TaskUploadTempPath({
	task: { branchId, orderlineId },
	fileUuid,
	fileExtension,
}: IGetS3TaskUploadPathParams) {
	return `/tmp/${branchId}/${orderlineId}/${fileUuid}.${fileExtension}`
}

export function getS3Path({
	outerDir,
	innerDir,
	fileUuid,
	fileExtension,
}: {
	outerDir: string
	innerDir: string
	fileUuid: string
	fileExtension: string
}) {
	return `/tmp/${outerDir}/${innerDir}/${fileUuid}.${fileExtension}`
}
